import { render } from "./SectorQuestion.vue?vue&type=template&id=4d256bdd"
import script from "./SectorQuestion.vue?vue&type=script&lang=js"
export * from "./SectorQuestion.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__